import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { faqsApi } from "../network/Network";
import Norecord from "../Components/Norecord";
import { norecord } from "../Constant/Index";

const PrivacyPolicy = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [getFaq, setGetFaq] = useState([]);
  const [visiblePics, setVisiblePics] = useState(2);

  const showMorePics = () => {
    setVisiblePics((prevVisiblePics) => prevVisiblePics + 2);
  };

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  //   Get Faq Api's
  useEffect(() => {
    faqsApi().then((res) => {
      setGetFaq(res?.data);
    });
  }, []);
  // =================

  return (
    <>
      <Header />
      <PageHeader pagename="FAQs" />
      <section className="services-pages pt-5 pb-5">
        <div className="container">
          <div className="row">
            {getFaq?.length > 0 ? (
              <>
                <div className="col-lg-10 mx-auto">
                  <div className="accordion">
                    {getFaq?.slice(0, visiblePics).map((item, findex) => (
                      <div
                        key={findex}
                        className={`accordion-item mt-3 ${
                          activeIndex === findex ? "active" : ""
                        }`}
                        onClick={() => handleToggle(findex)}
                      >
                        <h4 className="accordion-heading">
                          {item?.question}
                          <div className="edit-btn ">
                            <div className="edit-btn">
                              <i
                                className={`fas ${
                                  activeIndex === findex
                                    ? "fa-minus"
                                    : "fa-plus"
                                } accordion-icon nav-anchor`}
                              ></i>
                            </div>
                          </div>
                        </h4>
                        {activeIndex === findex && (
                          <div className="accordion-content">
                            <p>{item?.answer}</p>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </>
            ) : (
              <div className="no_recod_img text-center">
                <img
                  src={norecord}
                  alt="No records available"
                  className="img-fluid text-center "
                />
              </div>
            )}
          </div>
          {visiblePics < getFaq.length && (
            <div className="row">
              <div className="col-lg-12 text-center mt-4">
                <Link className="btn log-in level-7 primary-regular-font text-decoration-none">
                  <span onClick={showMorePics} className="bg-wrapper">
                    Load more
                  </span>
                </Link>
              </div>
            </div>
          )}
        </div>
      </section>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
